export const CREATE_STORE_ADDRESS = 'CREATE_STORE_ADDRESS';
export const UPDATE_STORE_ADDRESS = 'UPDATE_STORE_ADDRESS';
export const DELETE_STORE_ADDRESS = 'DELETE_STORE_ADDRESS';
export const LIST_STORE_ADDRESS = 'LIST_STORE_ADDRESS';